import { DemoSignUpPage } from '@features/onboarding/components/login/DemoSignUpPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/book-demo/sign-up')({ component: DemoSignUpPage });
